<template>
    <div style="
      display: flex;
      justify-content: center;
      height: 80vh;
      align-items: center;
    ">
        <van-overlay :show="isLoading">
            <div class="wrapper">
                <loading v-if="isLoading == true"></loading>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { Loading, Notify, Dialog, Toast, Field, Overlay } from "vant";
import service from "../../../api/user/index";
import { mapGetters,mapActions } from "vuex";
import loading from "../../../components/loading/loading";
export default {
    components: {
        [Loading.name]: Loading,
        [Notify.name]: Notify,
        [Dialog.Component.name]: Dialog.Component,
        [Toast.name]: Toast,
        [Field.name]: Field,
        [Overlay.name]: Overlay,
        loading
    },
    data() {
        return {
            IsShow: true,
            isLoading: true //loading状态
        };
    },
    computed: {
        ...mapGetters(["userInfo"])
    },
    methods: {
        ...mapActions(["wxLogin"]),
        getLoginMess() {
            let code = this.$route.query.code;
            let state = this.$route.query.state;
            if (code == undefined || state == undefined) {
                Notify({ type: "danger", message: "没有授权信息" });
            } else {
                console.log(state, this.userInfo.userId, 68);
                service.getAvatar({ code: code, userId: this.userInfo.userId }).then((res) => {
                    this.isLoading = false; 
                    let userInfoObj= this.userInfo
                    userInfoObj.avatarUrl = res.data
                    userInfoObj.identityType = this.userInfo.userType
                    userInfoObj.identityStatus = this.userInfo.statusName
                    console.log(userInfoObj, 55)
                    this.wxLogin(userInfoObj).then(() => {
                        console.log(state, "getAvatar");
                        this.$router.replace({
                            path: state
                        });

                    });
                });
            }
        }
    },
    mounted() {
        this.getLoginMess();
    }
};
</script>
